<div class="mt-filter filter-machine-type">
    <div class="title">
        <span class="label">{{'front' | lang}}</span>
        <span *ngIf="filter.required" class="mandatory">*</span>
    </div>

    <div class="filter">
        <app-dropdown-selector
            [isDisabled]="filter.uniqueSelection ? true : false"
            label="" 
            [items]="fronts"
            bindLabel="frontName"
            bindValue="frontId"
            [multiselect]="filter.multiselect ? true : false"
            [allSelectedOption]="filter.multiselect ? true : false"
            [ngModel]="selectedOption"
            (ngModelChange)="changeSelectedOption($event)">
        </app-dropdown-selector>
    </div>
</div>